<<<<<<< HEAD
<template>
  <div :class="item.gender == 1 ? 'cell-box male-left-border' : 'cell-box female-left-border'" style="height: 120px">
    <a-row>
      <a-col :span="18" @click="to_item_info" >
        <a-row>
          <div class="font-20">{{ title }}</div>
        </a-row>
        <a-row>
          <span class="font-10">出口号：</span> <span class="primary-color">{{ item.export_tag}}</span>
        </a-row>
        <a-row>
          <span class="font-10">GEBV：</span> <span class="primary-color">{{ item.gebv_volume  }}</span>
        </a-row>
        <a-row>
          <span class="font-10">进口号：</span> <span class="primary-color">{{ item.export_tag  }}</span>
        </a-row>
        <a-row>
          <span class="font-10">出生日期：</span> <span class="primary-color">{{ item.birth_date  }}</span>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    sub_title: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    to_item_info() {
      this.$router.push({
        path: `/breed_items/${this.item.id}`,
      }).catch(err => {});
    }
  }
}
</script>

<style>
</style>
=======
<template>
  <div :class="item.gender == 1 ? 'cell-box male-left-border' : 'cell-box female-left-border'" style="height: 120px">
    <a-row>
      <a-col :span="18" @click="to_item_info" >
        <a-row>
          <div class="font-20">{{ title }}</div>
        </a-row>
        <a-row>
          <span class="font-10">出口号：</span> <span class="primary-color">{{ item.export_tag}}</span>
        </a-row>
        <a-row>
          <span class="font-10">GEBV：</span> <span class="primary-color">{{ item.gebv_volume  }}</span>
        </a-row>
        <a-row>
          <span class="font-10">近交系数：</span> <span :style="{ color: getInbreedingColor(item.inbreedingCoefficient) }" class="primary-color">{{ formatInbreeding(item.inbreedingCoefficient) }}</span>
        </a-row>
        <a-row>
          <span class="font-10">出生日期：</span> <span class="primary-color">{{ item.birth_date  }}</span>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    sub_title: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    to_item_info() {
      this.$router.push({
        path: `/breed_items/${this.item.id}`,
      }).catch(err => {});
    },
    formatInbreeding(val) {
      if (val === null || val === undefined) return '待计算'
      return Number(val).toFixed(4)
    },
    getInbreedingColor(val) {
      if (val === null || val === undefined) return '#999'
      const v = Number(val)
      if (v === 0) return '#52c41a'      // 绿色 - 无近交
      if (v <= 0.0625) return '#52c41a'  // 绿色 - 低风险
      if (v <= 0.125) return '#faad14'   // 黄色 - 中风险
      return '#f5222d'                    // 红色 - 高风险
    }
  }
}
</script>

<style>
</style>
>>>>>>> test
